/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gcskew_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GC Skew Plotter`)
};

const es_gcskew_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Graficador de Sesgo GC`)
};

const de_gcskew_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GC-Skew-Plotter`)
};

const nl_gcskew_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GC-skewplotter`)
};

const fr_gcskew_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traceur de biais GC (GC skew)`)
};

const it_gcskew_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grafico dello skew GC`)
};

const pt_br2_gcskew_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plotador de GC Skew`)
};

const pt_gcskew_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gráfico de Assimetria GC`)
};

const ja_gcskew_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GCスキュープロッター`)
};

const zh_gcskew_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GC 偏斜绘图工具`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gcskew_h1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gcskew_h1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gcskew_h1", locale)
	if (locale === "en") return en_gcskew_h1(inputs)
	if (locale === "es") return es_gcskew_h1(inputs)
	if (locale === "de") return de_gcskew_h1(inputs)
	if (locale === "nl") return nl_gcskew_h1(inputs)
	if (locale === "fr") return fr_gcskew_h1(inputs)
	if (locale === "it") return it_gcskew_h1(inputs)
	if (locale === "pt-BR") return pt_br2_gcskew_h1(inputs)
	if (locale === "pt") return pt_gcskew_h1(inputs)
	if (locale === "ja") return ja_gcskew_h1(inputs)
	return zh_gcskew_h1(inputs)
};